// extracted by mini-css-extract-plugin
module.exports =  {"adminQueueAlert":"Ecnycy6r","left":"cyHmAbyK","badgeContainer":"sy4nKyF2","warning":"mulaN1Ua","badgeIcon":"cALtDcvM","info":"sTVmPV25"};